import React from 'react';
import { m } from 'framer-motion';
import { HammerIcon, RulerIcon, EuroIcon, ArrowRightIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
const steps = [{
  n: '1',
  title: 'Abre',
  icon: HammerIcon,
  text: 'Elige uno de los 7 objetos según la madera que tengas a mano hoy (o compra un tablero a 15€ en el Leroy).'
}, {
  n: '2',
  title: 'Mira',
  icon: RulerIcon,
  text: 'Consulta el despiece exacto en milímetros. Sin medidas raras, sin margen de error. Entiendes el plano en 5 minutos.'
}, {
  n: '3',
  title: 'Vende',
  icon: EuroIcon,
  text: 'Usa nuestras plantillas de anuncios para publicarlo antes de que se seque el barniz. En Wallapop o tu Instagram.'
}];
export function Method() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-133" data-mp="1nqe1kfx0drue">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-134" data-mp="3m460xw7w09c7">
        <SectionTag icon="🎯" data-id="element-135" data-mp="3m2bkau3nf3dx">El método "Producto en Mano"</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-136" data-mp="3i3c9isv8kcek">
          El Método "Producto en Mano"
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-137" data-mp="3ci9ku8myws2b">
          Preparar tu próxima venta es tan sencillo como seguir 3 pasos:
        </p>
      </div>

      <div className="mx-auto mt-8 flex max-w-4xl flex-col gap-4 px-4 sm:flex-row sm:items-stretch sm:gap-3 sm:px-6" data-id="element-138" data-mp="2ykbloah7x27e">
        {steps.map((step, i) => <React.Fragment key={step.n} data-id="element-139" data-mp="3q8v8sbra3s72" data-mpi={i}>
            <m.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex flex-1 flex-col items-center rounded-2xl border border-brown/20 bg-white p-6 text-center shadow-card" data-id="element-140" data-mp="3qb7y59zd94u5">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-brown/10" data-id="element-141" data-mp="d11wmgnwu9z8">
                <step.icon size={22} className="text-brown" data-id="element-142" data-mp="huwav4kqxwqx" />
              </div>
              <p className="mt-3 font-heading text-lg font-bold uppercase tracking-wide text-ink" data-id="element-143" data-mp="roa8ljp1mjc9">
                Paso {step.n}: {step.title}
              </p>
              <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-144" data-mp="iodh7ab9r6di">{step.text}</p>
            </m.div>
            {i < steps.length - 1 && <ArrowRightIcon size={20} className="mx-auto hidden flex-shrink-0 self-center text-brown/40 sm:block" aria-hidden="true" data-id="element-145" data-mp="dohct9yntcxf" />}
          </React.Fragment>)}
      </div>

      <p className="mx-auto mt-8 max-w-2xl px-4 text-center text-sm leading-relaxed text-muted sm:px-6 sm:text-base" data-id="element-146" data-mp="3zzgb4xexrzl">
        Sin maquinaria industrial. Sin desperdiciar material. Sin clientes pesados que te regatean cada euro.
      </p>
    </section>;
}